export default "__VITE_ASSET__DjwGgngt__"